import axios from "../../config/axiosConfig";
import {
    FINYEAR_CUSTOMER_REQUEST,
    FINYEAR_CUSTOMER_REQUEST_FAILURE,
    GET_FINYEAR_CUSTOMERS,
} from "../types";

export const getLinkedFinyearCustomers = (finyearId) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: FINYEAR_CUSTOMER_REQUEST });
            return axios.get("/linkFinyearCustomer/getAll", { params: { finyearId } }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_FINYEAR_CUSTOMERS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FINYEAR_CUSTOMER_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_CUSTOMER_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const linkFinyearCustomers = (data) => {
    return async (dispatch) => {
        try {
            dispatch({ type: FINYEAR_CUSTOMER_REQUEST });
            data.forEach(async (val) => {
                await axios.put(`/linkFinyearCustomer/link-customer`, { ...val });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_CUSTOMER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const unlinkFinyearCustomers = (ids) => {
    return async (dispatch) => {
        try {
            dispatch({ type: FINYEAR_CUSTOMER_REQUEST });
            ids.forEach(async (id) => {
                await axios.delete(`/linkFinyearCustomer/delete/${id}`);
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_CUSTOMER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};